import { render } from "./ProjectSitesPage.vue?vue&type=template&id=baf0841e"
import script from "./ProjectSitesPage.vue?vue&type=script&lang=js"
export * from "./ProjectSitesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__